<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
          <li class="breadcrumb-item" disabled><a routerLink="/corporate/subscription-license-rights">License Rights</a></li>
          <li class="breadcrumb-item active" aria-current="page">Edit License Rights</li>
      </ol>
  </nav>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <label>Subscription</label>
              <input type="text" class="form-control" [value]="planTitle" readonly>
            </div>
            <div class="form-group">
              <label>License Rights</label>
              <div *ngIf="licenses.length === 0" class="mt-1">No license available.</div>
              <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0" *ngIf="licenses.length > 0">
                <tr>
                  <th>License</th>
                  <th>Code</th>
                  <th>Category</th>
                  <th width="80" style="text-align:center" *ngFor="let act of actions">{{act.label}}</th>
                </tr>
                <tr *ngFor="let item of licenses">
                  <td>{{item.license_name}}</td>
                  <td>{{item.license_code}}</td>
                  <td>{{item.category_name}}</td>
                  <td align="center" *ngFor="let act of actions">
                    <label class="custmCheck">
                      <input type="checkbox" [checked]="isChecked(item, act.key)"
                        (change)="toggle(item, act.key, $event.target.checked)">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button class="btn btn-round btn-margo-action" (click)="saveRights()">Save
              </button>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
